import React from "react"
import '../../index.css'

function Navbar(){
    return(
        <>
        <div id="abs">
             <span id="companyName">EASY</span><span id="companyName2">EXIT</span>
        </div>
        </>
    )
}
export default Navbar